<template>
  <div class="Background">
    <PlayList :group-id="groupId" />

    <AllTable v-show="groupId === 'all'" />

    <CustomTable v-show="groupId !== 'all'" :group-id="Number(groupId)" />
  </div>
</template>

<script>
import PlayList from '@/components/playlist/PlaylistForm.vue';
import CustomTable from '@/components/playlist/PlaylistCustomTable.vue';
import AllTable from '@/components/playlist/PlaylistAllTable.vue';
import { mapActions } from 'vuex';

export default {
  components: {
    PlayList,
    CustomTable,
    AllTable
  },
  methods: {
    ...mapActions('group', ['updateSelectedGroupId', 'updateSelectedGroupName']),
  },
  computed: {
    groupId() {
      return this.$store.state.group.selectedGroupId;
    },
  },
  watch: {
    groupId(newValue, oldValue) {
      if (newValue !== oldValue) {
        //console.log('view', newValue);

      }
    },
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped></style>